import React from 'react';
import ArticleDetailUI from './ContentUI';

const ArticleDetail = ({ data }: { data: any }) => {
  return (
    <ArticleDetailUI
      model={data['model']}
      articleList={data['articleList']}
      contentData={data['contentData']}
      recommendTags={data['recommendTags']}
      randomHairList={data?.randomHairList ?? []}
      hairArticleData={data?.hairArticleData ?? {}}
    />
  );
};

export default ArticleDetail;
